import axios from "axios";

export default {
    namespaced: true,
    state: {
        //
    },
    getters: {
        //
    },
    mutations: {
        //
    },
    actions: {
        capture({ state }, { event, attributes }) {
            return new Promise((resolve, reject) => {
                axios.post(`analytics/capture/${event}`, {attributes}).then(resolve).catch(reject);
            });
        },

        isOn({ state }, feature) {
            return new Promise((resolve, reject) => {
                axios.get(`analytics/feature/${feature}`).then(resolve).catch(reject);
            });
        }
    },
}
